<template>
	<v-dialog v-model="shareUserDialog" width="700">
    <customDialog>
      <template v-slot:title>
        {{t('shardMemberSetting')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img"
						@click="shareUserDialog = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
						<v-col class="ma-0 pa-0 pb-3" cols="12" align="left">
							<v-col class="ma-0 pa-0 pb-5" cols="12">
								<v-row class="ma-0 pa-0" align="center">
									<v-col class="ma-0 pa-0 pr-2" cols="10">
                    <v-autocomplete
								    	v-model="shareUserInputValue"
								    	:items="allShareUserList"
								    	:loading="searchLoading"
								    	:search-input.sync="search" append-icon=""
								    	color="white" dark hide-no-data hide-selected outlined dense hide-details
								    	item-text="name"
								    	:placeholder="t('shareInputPlaceholder')"
								    	return-object style="width:100%;"
								    ></v-autocomplete>
									</v-col>
									<v-col class="ma-0 pa-0" cols="2">
										<v-btn width="100%" height="2rem" class="ma-0 pa-0" 
											id="blue_btn" elevation="0" @click="addShareUser">
												{{t('add2')}}
										</v-btn>
									</v-col>
								</v-row>
							</v-col>
							<v-col class="ma-0 pa-0" cols="12" id="user_list">
								<v-col class="ma-0 pa-0 pl-1 pr-1" cols="12"
									v-for="(item, index) in shareUserList" :key="index">
									<v-col class="ma-0 pa-2 pt-1 pb-1" cols="12" id="user_item">
										<v-row class="ma-0 pa-0" align="center" justify="space-between">
											<v-col class="ma-0 pa-0 pl-3" cols="auto">{{item.name}}</v-col>
											<v-col class="ma-0 pa-0" cols="auto">{{item.mailAddress}}</v-col>
											<v-btn width="auto" height="auto" class="ma-0 pa-0 mr-5" 
												id="back_clean_btn" elevation="0" @click="deleteShareUser(index)">
												<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0"
													src="@/assets/images/close.png"></v-img>
											</v-btn>
										</v-row>
									</v-col>
								</v-col>
							</v-col>
							<v-col class="ma-0 pa-0 mt-5" cols="12">
								<v-row class="ma-0 pa-0" align="center" justify="center">
									<v-btn width="8rem" height="auto" class="ma-0 pa-2" 
										id="grey_btn" elevation="0" @click="cancelEdit">
											{{t('back')}}
									</v-btn>
									<v-btn width="8rem" height="auto" class="ma-0 pa-2 ml-2"
										:loading="loading"
										id="blue_btn" elevation="0" @click="requestUpdateStoreGroup">
											{{t('groupCreate')}}
									</v-btn>
								</v-row>
							</v-col>
						</v-col>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import CustomDialog from '@/components/Modal.vue';
import { isEmpty, cloneDeep } from 'lodash';
export default {
	props: {
		dialogVisible: Boolean,
		group: Array | Object
	},
	components: {
		CustomDialog
	},
	mixins: [mixin.common],
	data: () => ({
    shareUserDialog: false,
		currentGroupId: '',
		currentGroup: {},
		allShareUserList: [],
		shareUserList: [],
		setshareUserListParams: [],
		shareUserInputValue: {},
    searchLoading: false,
		loading: false,
		tempDeleteSharedUser: [],
		search: ''
	}),
	watch: {
		dialogVisible: function(item) {
			this.shareUserDialog = item;
			if(item) {
				this.tempDeleteSharedUser = [];
				this.shareUserList = cloneDeep(this.currentGroup.sharedUserStoreGroups);
			}
		},
		shareUserDialog: function(item) {
			this.$emit('visible', item);
		},
		group: function(item) {
			this.currentGroup = item;
			this.currentGroupId = item.id;
			this.shareUserList = cloneDeep(item.sharedUserStoreGroups);
		}
	},
	created() {
		this.currentGroupId = this.$route.query.groupId;
		let savedStoreGroupList = this.$store.getters.getStoreGroupList;
		this.currentGroup = savedStoreGroupList.find(r => r.id === this.$route.query.groupId);
		this.shareUserList = cloneDeep(this.currentGroup.sharedUserStoreGroups);
	},
	mounted() {
		this.getAllShareUserList();
	},
	methods: {
		async getAllShareUserList() {
			let params = {};
      let unisCustomerCd = this.$store.getters.getUserDetail.unisCustomerCd;
			await this.networkController.getShareUser(params, unisCustomerCd).then(async (res) => {
				const userList = this.checkShareUserList(res.data.accounts);
				console.log('%cShare user account\n', "color:#008DD0;", userList);
				this.allShareUserList = userList;
			}).catch(error => { });
		},
		addShareUser() {
			const { name, mailAddress, umid, userName } = this.shareUserInputValue || {};

			if (isEmpty(umid)) {
				this.showToastMessage(this.tmb('failAddShareUser'));
				return;
			}
			if (isEmpty(mailAddress)) {
				this.showToastMessage('そのユーザーはメールアドレスを持たないユーザーです。');
				return;
			}

			const isAlreadyAdded = this.shareUserList.some(user => user.umid === umid);
			if (isAlreadyAdded) {
				this.showToastMessage(this.tmb('userAlreadyAdded'));
				return;
			}

			this.shareUserList.push({ mailAddress, umid, name, userName });
			this.shareUserInputValue = {};
		},
		deleteShareUser(index) {
			this.tempDeleteSharedUser.push(this.shareUserList[index]);
			this.shareUserList.splice(index, 1);
		},
		cancelEdit() {
			if(this.tempDeleteSharedUser.length != 0) {
				this.tempDeleteSharedUser.forEach(user => {
					this.shareUserList.push(user);
				})
			}
			this.shareUserDialog = false;
		},
		async requestUpdateStoreGroup() {
			this.loading = true;
			let params = {
				groupName: this.currentGroup.groupName,
				sharedUserStoreGroups: this.shareUserList,
				stores: this.currentGroup.stores == undefined ? [] : this.currentGroup.stores,
			};
			await this.networkController.updateStoreGroup(params, this.currentGroup.id)
			.then(async (res) => {
				console.log(res.data);
				let oldStoreGroupList = this.$store.getters.getStoreGroupList;
				let currentGroupIndex = oldStoreGroupList.findIndex(r => r.id === this.currentGroupId);
				oldStoreGroupList[currentGroupIndex].sharedUserStoreGroups = this.shareUserList;
				let newStoreGroup = {
					sharedUserStoreGroups: this.shareUserList,
					...oldStoreGroupList[currentGroupIndex]
				};
				oldStoreGroupList[currentGroupIndex] = newStoreGroup;
				await this.$store.commit('setStoreGroupList', oldStoreGroupList);
				this.$emit('update', newStoreGroup);
				this.loading = false;
				this.shareUserDialog = false;
				this.showToastMessage(this.tmb('requestSuccess'));
			}).catch(error => {
				this.loading = false;
			});
		},
	}
}
</script>

<style lang="scss" scoped>
#group_box {
	background-color: #171921;
	border: 1px solid #6A6A6A;
	color: white;
	border-radius: 5px;
	max-width: 700px;
}
#group_box_title {
	border-bottom: 1px solid #6A6A6A;
}
#user_list {
	border: 1px solid #4A4A4A;
	overflow: auto;
	min-height: 350px;
	max-height: 350px;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#group_input {
	background-color: #272727;
	border: 1px solid #4A4A4A;
	border-radius: 4px;
	color: white;
	padding: 5px;
}
#user_item {
	border-bottom: 1px solid #4A4A4A;
}
.v-list{
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0;
  }
	.v-treeview--dense .v-treeview-node__root {
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node .v-treeview-node--leaf {
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node__checkbox { // 트리뷰 체크박스 CSS
		background-color: white;
		border-radius: 5px;
		width: 18px;
		height: 18px;
		margin-left: 8px;
		margin-right: 5px;
	}
	.v-input__slot {
		padding-right: 2px !important;
		min-height: 2rem !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
		// v-skeleton-loader css 설정
	.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-three-line {
		background: #171921 !important;
	}
	.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-two-line {
		background: #171921 !important;
	}

	.v-autocomplete {
		background-color: #272727;
	}
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 30px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
</style>